import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=f01251b6&scoped=true&"
import script from "./NotificationsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=f01251b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01251b6",
  null
  
)

export default component.exports